
export default class DrawUtils {

	static get RECTANGLE_TOOL () {
		return 'rectangle';
	}

	static get POLYGON_TOOL () {
		return 'polygon';
	}

	static get POLYLINE_TOOL () {
		return 'polyline';
	}

	static get CIRCLEMARKER_TOOL () {
		return 'circlemarker';
	}

	static get DEFAULT_COLOR () {
		return '#0066D5';
	}
};



// WEBPACK FOOTER //
// ./src/utils/drawUtils.js